import {
  READ_ACTION,
  DASHBOARD_FTR_INVEST,
  SUBSCRIPTION_REPLACEMENTS_STATICS,
  DASHBOARD_CX,
  DASHBOARD_FRANQ_FINDER,
  BI_REPORTS_MENU,
} from "@/constants/resources";

export default [
  {
    title: "Indicadores Admin",
    icon: "none",
    children: [
      {
          title: "Dashboard FTR Invest",
          route: "dashboard-ftr-invest",
          icon: "BarChart2Icon",
          resource: DASHBOARD_FTR_INVEST,
          action: READ_ACTION,
      },
      {
          title: "Troca de Assinatura",
          route: "kpi-subscription-replacements-statics",
          icon: "RefreshCwIcon",
          resource: SUBSCRIPTION_REPLACEMENTS_STATICS,
          action: READ_ACTION,
      },
      {
        title: "Dashboard CX",
        route: "dashboard-cx",
        icon: "UsersIcon",
        resource: DASHBOARD_CX,
        action: READ_ACTION,
      },
      {
        title: "Gestão Franq Finder",
        route: "dashboard-franq-finder",
        icon: "CompassIcon",
        resource: DASHBOARD_FRANQ_FINDER,
        action: READ_ACTION,
      },
      {
        title: "Relatórios BI",
        route: "bi-report-list",
        icon: "PieChartIcon",
        resource: BI_REPORTS_MENU,
        action: READ_ACTION,
      },
    ],
  }
];